// extracted by mini-css-extract-plugin
module.exports = {"bannerIconWrapper":"BannerIcons_bannerIconWrapper__KNgyO","button":"BannerIcons_button__oHh0F"};